export default __webpack_public_path__ + "static/media/core-blockchain-slogan.acc4de6b.jpg";